interface CloseButtonSVGProps {
    color?: string
    width?: number
    height?: number
}

export const CloseButtonSVG = ({ color = '#D9D9D9', width = 58, height = 58 }: CloseButtonSVGProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_15_17006)">
                <path
                    d="M42.3784 15.6216C41.5495 14.7928 40.2106 14.7928 39.3818 15.6216L30.4983 24.5051C29.6694 25.334 28.3306 25.334 27.5017 24.5051L18.6182 15.6216C17.7894 14.7928 16.4505 14.7928 15.6216 15.6216C14.7928 16.4505 14.7928 17.7894 15.6216 18.6182L24.5051 27.5017C25.334 28.3306 25.334 29.6694 24.5051 30.4983L15.6216 39.3818C14.7928 40.2106 14.7928 41.5495 15.6216 42.3784C16.4505 43.2072 17.7894 43.2072 18.6182 42.3784L27.5017 33.4949C28.3306 32.666 29.6694 32.666 30.4983 33.4949L39.3818 42.3784C40.2106 43.2072 41.5495 43.2072 42.3784 42.3784C43.2072 41.5495 43.2072 40.2106 42.3784 39.3818L33.4949 30.4983C32.666 29.6694 32.666 28.3306 33.4949 27.5017L42.3784 18.6182C43.2072 17.7894 43.2072 16.4505 42.3784 15.6216Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_15_17006">
                    <rect width="58" height="58" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
